<template>
  <form>
    <RiskAssessmentForm
      :name="network.name"
      :type="network.type"
      :sections="displayedSections"
      :interventions="displayedInterventions"
      :suggestions="displayedSuggestions"
      :editable="editable"
      @check="mutableSections = $event"
    />
  </form>
</template>

<script>
import RiskAssessmentForm from '@/components/sites/riskAssessments/RiskAssessmentForm.vue';

export default {
    name: 'RiskAssessmentSteamNetworkForm',
    components: {
        RiskAssessmentForm,
    },
    props: {
        sections: {
            type: Array,
            default: () => [],
        },
        editable: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            displayedSections: [
                {
                    name: this.$t('riskAnalysis.physicalInspection'),
                    fields: [
                        {
                            key: 'V1',
                            label: this.$t('riskAnalysis.steamNetwork.waterTube'),
                            yesValue: 3,
                            noValue: 0,
                            value: null,
                        },
                        {
                            key: 'V2',
                            label: this.$t('riskAnalysis.steamNetwork.fireTube'),
                            yesValue: 0,
                            noValue: 0,
                            value: null,
                        },
                        {
                            key: 'V3',
                            label: this.$t('riskAnalysis.steamNetwork.depositPresence'),
                            yesValue: 3,
                            noValue: 0,
                            value: null,
                        },
                        {
                            key: 'V4',
                            label: this.$t('riskAnalysis.steamNetwork.internalCorrosion'),
                            yesValue: 3,
                            noValue: 0,
                            value: null,
                        },
                        {
                            key: 'V5',
                            label: this.$t('riskAnalysis.steamNetwork.condensateCorrosion'),
                            yesValue: 2,
                            noValue: 0,
                            value: null,
                        },
                        {
                            key: 'V6',
                            label: this.$t('riskAnalysis.steamNetwork.carryOverInSteam'),
                            yesValue: 2,
                            noValue: 0,
                            value: null,
                        },
                        {
                            key: 'V7',
                            label: this.$t('riskAnalysis.steamNetwork.leakingBottom'),
                            yesValue: 1,
                            noValue: 0,
                            value: null,
                        },
                        {
                            key: 'V8',
                            label: this.$t('riskAnalysis.steamNetwork.leakingSurface'),
                            yesValue: 1,
                            noValue: 0,
                            value: null,
                        },
                        {
                            key: 'V9',
                            label: this.$t('riskAnalysis.steamNetwork.overflowFeed'),
                            yesValue: 2,
                            noValue: 0,
                            value: null,
                        },
                        {
                            key: 'V10',
                            label: this.$t('riskAnalysis.steamNetwork.exceededSteamPlume'),
                            yesValue: 1,
                            noValue: 0,
                            value: null,
                        },
                    ],
                },
                {
                    name: this.$t('riskAnalysis.applicationConditions'),
                    fields: [
                        {
                            key: 'V11',
                            label: this.$t('riskAnalysis.steamNetwork.duplexWater'),
                            yesValue: 0,
                            noValue: 3,
                            value: null,
                        },
                        {
                            key: 'V12',
                            label: this.$t('riskAnalysis.steamNetwork.blowdownControl'),
                            yesValue: 0,
                            noValue: 2,
                            value: null,
                        },
                        {
                            key: 'V13',
                            label: this.$t('riskAnalysis.steamNetwork.inhibitorInjectionControl'),
                            yesValue: 0,
                            noValue: 2,
                            value: null,
                        },
                        {
                            key: 'V14',
                            label: this.$t('riskAnalysis.steamNetwork.oxygenScavenger'),
                            yesValue: 0,
                            noValue: 2,
                            value: null,
                        },
                        {
                            key: 'V15',
                            label: this.$t('riskAnalysis.steamNetwork.steamInjector'),
                            yesValue: 0,
                            noValue: 2,
                            value: null,
                        },
                        {
                            key: 'V16',
                            label: this.$t('riskAnalysis.steamNetwork.boilerFeed'),
                            yesValue: 0,
                            noValue: 2,
                            value: null,
                        },
                        {
                            key: 'V17',
                            label: this.$t('riskAnalysis.steamNetwork.makeUpExceed10'),
                            yesValue: 0,
                            noValue: 0,
                            value: null,
                        },
                        {
                            key: 'V18',
                            label: this.$t('riskAnalysis.steamNetwork.regularOperation'),
                            yesValue: 2,
                            noValue: 0,
                            value: null,
                        },
                        {
                            key: 'V19',
                            label: this.$t('riskAnalysis.steamNetwork.waterHardness'),
                            yesValue: 0,
                            noValue: 2,
                            value: null,
                        },
                        {
                            key: 'V20',
                            label: this.$t('riskAnalysis.steamNetwork.dailyTesting'),
                            yesValue: 0,
                            noValue: 1,
                            value: null,
                        },
                        {
                            key: 'V21',
                            label: this.$t('riskAnalysis.steamNetwork.safetyEquipmentOnSite'),
                            yesValue: 0,
                            noValue: 1,
                            value: null,
                        },
                        {
                            key: 'V22',
                            label: this.$t('riskAnalysis.steamNetwork.sampleCoolerAvailable'),
                            yesValue: 0,
                            noValue: 1,
                            value: null,
                        },
                    ],
                },
                {
                    name: this.$t('riskAnalysis.analyticalResults'),
                    fields: [
                        {
                            key: 'V23',
                            label: this.$t('riskAnalysis.steamNetwork.minimalConcentration'),
                            yesValue: 0,
                            noValue: 2,
                            value: null,
                        },
                        {
                            key: 'V24',
                            label: this.$t('riskAnalysis.steamNetwork.lowConcentration'),
                            yesValue: 0,
                            noValue: 2,
                            value: null,
                        },
                        {
                            key: 'V25',
                            label: this.$t('riskAnalysis.steamNetwork.boilerWaterConductivity'),
                            yesValue: 0,
                            noValue: 1,
                            value: null,
                        },
                        {
                            key: 'V26',
                            label: this.$t('riskAnalysis.steamNetwork.condensateWaterConductivity'),
                            yesValue: 0,
                            noValue: 2,
                            value: null,
                        },
                        {
                            key: 'V27',
                            label: this.$t('riskAnalysis.steamNetwork.AdequatMineral'),
                            yesValue: 0,
                            noValue: 2,
                            value: null,
                        },
                        {
                            key: 'V28',
                            label: this.$t('riskAnalysis.steamNetwork.hardnessPresence'),
                            yesValue: 3,
                            noValue: 0,
                            value: null,
                        },
                    ],
                },
            ],
            mutableSections: this.sections,
            network: {
                name: null,
                type: null,
            },
            riskAnalysis: {
                network: null,
                fields: [],
            },
        };
    },
    computed: {
        displayedInterventions() {
            const displayedInterventions = [];

            if (this.results('V1') && this.results('V3')) {
                displayedInterventions.push(this.$t('riskAnalysis.steamNetwork.interventions.descalingRequired'));
            }
            if (this.results('V11') === false && this.results('17') && this.results('V18') === false) {
                displayedInterventions.push(this.$t('riskAnalysis.steamNetwork.interventions.waterSoftener'));
            }
            if (this.results('V9') && this.results('V28')) {
                displayedInterventions.push(this.$t('riskAnalysis.steamNetwork.interventions.correctHardness'));
            }

            return displayedInterventions;
        },
        displayedSuggestions() {
            const displayedSuggestions = [];

            if (this.results('V3')) {
                displayedSuggestions.push(this.$t('riskAnalysis.steamNetwork.suggestions.descaleBoiler'));
            }
            if (this.results('V7')) {
                displayedSuggestions.push(this.$t('riskAnalysis.steamNetwork.suggestions.repairBottomValves'));
            }
            if (this.results('V8')) {
                displayedSuggestions.push(this.$t('riskAnalysis.steamNetwork.suggestions.repairSurfaceValves'));
            }
            if (this.results('V9')) {
                displayedSuggestions.push(this.$t('riskAnalysis.steamNetwork.suggestions.checkLeaks'));
            }
            if (this.results('V10')) {
                displayedSuggestions.push(this.$t('riskAnalysis.steamNetwork.suggestions.checkOperation'));
            }
            if (this.results('V13') === false && this.results('V14') === false) {
                displayedSuggestions.push(this.$t('riskAnalysis.steamNetwork.suggestions.automateInjection'));
            }
            if (this.results('V16') === false) {
                displayedSuggestions.push(this.$t('riskAnalysis.steamNetwork.suggestions.increaseTemperature'));
            }
            if (this.results('V19') === false) {
                displayedSuggestions.push(this.$t('riskAnalysis.steamNetwork.suggestions.increaseTesting'));
            }
            if (this.results('V21') === false) {
                displayedSuggestions.push(this.$t('riskAnalysis.steamNetwork.suggestions.aquireEquipment'));
            }
            if (this.results('V22') === false) {
                displayedSuggestions.push(this.$t('riskAnalysis.steamNetwork.suggestions.installSampleCooler'));
            }
            if (this.results('V23') === false && this.results('V24') === false) {
                displayedSuggestions.push(this.$t('riskAnalysis.steamNetwork.suggestions.auditAntiCorrosion'));
            }
            if (this.results('V25') === false && this.results('V26') === false && this.results('V6')) {
                displayedSuggestions.push(this.$t('riskAnalysis.steamNetwork.suggestions.increasePurge'));
            }
            if (this.results('V28')) {
                displayedSuggestions.push(this.$t('riskAnalysis.steamNetwork.suggestions.verifyCondensateContamination'));
            }

            return displayedSuggestions;
        },
        fields() {
            const fields = [];

            this.displayedSections.forEach(section => {
                section.fields.forEach(field => {
                    fields.push({ fieldID: field.key, value: field.value });
                });
            });

            return fields;
        },
        results() {
            return fieldID => this.fields.find(field => field.fieldID === fieldID).value;
        },
    },
    watch: {
        fields() {
            this.riskAnalysis.fields = this.fields;
            this.updateData();
        },
    },
    created() {
        this.network.name = this.$attrs.name;
        this.network.type = this.$attrs.type;
        this.riskAnalysis.network = this.$attrs.network;
        if (this.$attrs.component) {
            this.network.name = this.$attrs.componentName;
            this.network.type = this.$attrs.componentType;
            this.riskAnalysis.component = this.$attrs.component;
        }

        if (this.mutableSections.length) {
            this.displayedSections = this.displayedSections.map((section, i) => ({
                ...section,
                fields: this.transformFields(i, section.fields),
            }));
        }
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.riskAnalysis);
        },
        transformFields(i, fields) {
            return fields.map((field, j) => ({
                ...field,
                value: this.mutableSections[i].fields[j].value,
            }));
        },
    },

};
</script>
